import { Injectable } from '@angular/core';
import {
    EntityTypeCustomFieldSectionClient,
    EntityTypeCustomFieldSectionView
} from '@services/http/clients/api-proxies';
import { lastValueFrom } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class CustomFieldSectionService {
    constructor(private readonly client: EntityTypeCustomFieldSectionClient) {}

    async getByEntityId(id: number): Promise<EntityTypeCustomFieldSectionView[]> {
        return await lastValueFrom(this.client.entityTypeCustomFieldSectionGetByEntityType(id));
    }
}
